"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var FinanceReconciliationsList_1 = require("./component/FinanceReconciliationsList");
var FinanceReconciliationEditor_1 = require("./component/FinanceReconciliationEditor");
var FinanceReconciliationPartnersList_1 = require("./component/FinanceReconciliationPartnersList");
var PFinanceReconciliationsList = /** @class */ (function (_super) {
    __extends(PFinanceReconciliationsList, _super);
    function PFinanceReconciliationsList(props) {
        return _super.call(this, props) || this;
    }
    PFinanceReconciliationsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AP = this.props.pprogramsList.Subscribe("*", function (id, data) {
            _this.setState({ avail_pprograms: data.data });
        });
        this.SID_AB = this.props.brandsList.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_pprograms: [],
            avail_brands: []
        }, function () {
            _this.props.pprogramsList.LoadData();
            _this.props.brandsList.LoadData();
        });
    };
    PFinanceReconciliationsList.prototype.componentWillUnmount = function () {
        this.props.pprogramsList.UnSubscribe(this.SID_AP);
        this.props.brandsList.UnSubscribe(this.SID_AB);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PFinanceReconciliationsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PFinanceReconciliationsList.prototype.onBrandFilterChanged = function (allPPrograms, PProgramId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllPPrograms(allPPrograms, true);
        }
        if (Action === "add") {
            this.props.state.addPProgram(PProgramId, true);
        }
        if (Action === "remove") {
            this.props.state.delPProgram(PProgramId, true);
        }
    };
    PFinanceReconciliationsList.prototype.backToListClick = function () {
        this.setState({ edit_mode: "LIST" });
    };
    PFinanceReconciliationsList.prototype.newRevshareClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PFinanceReconciliationsList.prototype.editRevshareClick = function (val) {
        this.setState({ edit_mode: "EDIT", record: val });
    };
    PFinanceReconciliationsList.prototype.detailsRevshareClick = function (val) {
        this.setState({ edit_mode: "DETAIL", record: val });
    };
    PFinanceReconciliationsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(FinanceReconciliationsList_1.default, { data: this.props.data, state: this.props.state, onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, BrandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onNewReconciliation: this.newRevshareClick.bind(this), onEditReconciliation: this.editRevshareClick.bind(this), onDetailsReconciliation: this.detailsRevshareClick.bind(this) }));
        }
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(FinanceReconciliationEditor_1.default, { data: this.props.data, state: this.props.state, record: null, availBrands: this.state.avail_brands, onGoBack: this.backToListClick.bind(this), availPPrograms: this.state.avail_pprograms }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(FinanceReconciliationEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, availBrands: this.state.avail_brands, onGoBack: this.backToListClick.bind(this), availPPrograms: this.state.avail_pprograms }));
        }
        if (this.state.edit_mode === "DETAIL") {
            return (React.createElement(FinanceReconciliationPartnersList_1.default, { data: this.props.dataPartners, state: this.props.state, record: this.state.record, onGoBack: this.backToListClick.bind(this), errDialog: this.props.errDialog }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PFinanceReconciliationsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PFinanceReconciliationsList.getPageDescription = function (state) {
        return {
            icon: "balance-scale",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_finance_reconciliations_list + "-id",
            itemTitle: "Сверки",
            route: routes_1.routes.page_finance_reconciliations_list,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PFinanceReconciliationsList;
}(React.Component));
exports.default = PFinanceReconciliationsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_reconciliations/ui/PFinanceReconciliationsList.tsx
// module id = 2553
// module chunks = 0